/**
 * { item_description }
 */
import Model from '@/models/Model'
import APayable from '@/models/Actions/APayable'

/**
 * This class describes a pch purchase debit note.
 *
 * @class      PchPurchaseDebitNote (name)
 */
export default class PchPurchaseDebitNote extends Model {

    /**
     * { item_description }
     */
    static includes = [
        'pch_provider',
        'pch_provider_branch_offices',
        'pch_payment_condition',
    ]

    /**
     * { function_description }
     *
     * @return     {PchPurchaseDebitNote}  The pch purchase debit note.
     */
    cancelPurchaseCreditNote() {
        return new PchPurchaseDebitNote({
            id: 'cancel_credit_note'
        })
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get net_total() {
    	return this.new_subtotal
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    set net_total(val) {
    	this.iva 			= Math.round(Math.max(val * 0.19, 1))
    	this.total 			= Math.round(val * 1.19)
    	this.new_subtotal 	= (val)
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get payable_str() {
        return this.getProperty('payable', false) ? 'Desbloqueada' : 'Bloqueada'
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get pch_payment_condition_type() {
        return this.getProperty('pch_payment_condition.type', '-')
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get pch_provider_business_name() {
    	return this.pch_provider ? this.pch_provider.business_name : '-'
    }

    /**
     * Resets the object.
     *
     * @return     {Object}  { description_of_the_return_value }
     */
    reset() {

        //
        this.document_type = this.invoice_number ? 0 : 1
        this.pch_provider_branch_offices = this.pch_provider.pch_provider_branch_offices || []
        
        //
        return this
    }

    /**
     * { function_description }
     *
     * @return     {string}  { description_of_the_return_value }
     */
    resource() {
        return 'pch_purchase_debit_note'
    }

    /**
     * Returns a create representation of the object.
     *
     * @return     {<type>}  Create representation of the object.
     */
    toCreate() {
        return this.clean([
            'pch_provider_branch_offices_id',
            'pch_provider_id',
            'emission_date',
            'payment_date',
            'debit_note_number',
            'pch_payment_condition_id',
            'invoice_number',
            'extra_tax',
            'new_subtotal',
            'iva',
            'total',
        ])
    }

    /**
     * Returns a cancel purchase credit note representation of the object.
     *
     * @return     {<type>}  Cancel purchase credit note representation of the object.
     */
    toCancelPurchaseCreditNote() {
    	return this.clean([
            'pch_provider_branch_offices_id',
            'pch_provider_id',
            'emission_date',
            'payment_date',
            'debit_note_number',
            'pch_payment_condition_id',
            'credit_note_number',
        ])
    }

    /**
     * Returns a payable representation of the object.
     *
     * @return     {<type>}  Payable representation of the object.
     */
    toPayable() {
        return {
            payable: !this.payable
        }
    }

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    togglePayable() {
        return this.hasMany(APayable)
    }
}